export const ru = {
    button: 'Назад',
    'many-message-limit-title':
        'В эту группу можно добавить не более {count} объявлений.',
    'message-limit-text':
        'Выберите меньшее количество креативов или создайте новую группу объявлений.',
    'message-no-multi-text':
        'При редактировании графического объявления можно выбрать только один креатив',
    'message-no-multi-title': 'Выберите один креатив',
    'one-message-limit-title':
        'В эту группу можно добавить только одно объявление.',
    'some-message-limit-title':
        'В эту группу можно добавить не более {count} объявления.'
};
